import { Inject, Injectable } from '@angular/core';
import { ISvcAppSettingsValue, SVC_APP_SETTINGS, SvcAppSettingsValue } from './svc-app-settings.token';
import { updateDateFormatCookie, updateDelimiterTypeCookie } from '../functions/legacy-cookie-integrations';
import { DEFAULT_DELIMITER_TYPE, SvcDelimiterType } from './enums/svc-delimiter-type.enum';
import { SvcModule } from './enums/svc-module.enum';

@Injectable({
  providedIn: 'root',
})
export class SvcAppSettings implements ISvcAppSettingsValue {
  private _settings: SvcAppSettingsValue;

  public get applicationId(): string {
    return this._settings.applicationId;
  }
  public get applicationName(): string {
    return this._settings.applicationName;
  }
  public get module(): SvcModule {
    return this._settings.module;
  }
  public get dateFormat(): string {
    return this._settings.dateFormat;
  }
  public get delimiterSymbol(): string {
    return this._settings.delimiterSymbol;
  }
  public get dateFormatAsMask(): string {
    const separatorSymbol = this.dateFormat.replace(/[aA-zZ]/g, '')[0] ?? '';
    return this.dateFormat
      ?.split('')
      .map((char) => (char !== separatorSymbol ? '0' : separatorSymbol))
      .join('');
  }
  public get currencyAcronym(): string {
    return this._settings.currencyAcronym;
  }

  constructor(@Inject(SVC_APP_SETTINGS) settings: SvcAppSettingsValue) {
    this._settings = settings ?? <SvcAppSettingsValue>{};
  }

  public setCurrencyAcronym(symbol: string): void {
    this._settings.currencyAcronym = symbol;
  }

  public setDateFormat(rawFormat: string): void {
    const separatorSymbol = rawFormat === 'YYYYMMDD' ? '-' : '/';
    rawFormat = rawFormat.split('').reduce((prev, curr, index) => {
      curr = /^[DY]$/g.test(curr) ? curr.toLowerCase() : curr;
      const lastChar = prev.replace(/\//g, '').split('').pop();
      return prev + (index > 0 && lastChar !== curr ? separatorSymbol : '') + curr;
    }, '');
    
    // Correção: garantir que o ano sempre tenha 4 dígitos (yyyy)
    // Corrige formatos incorretos como 'dd/MM/yyy' para 'dd/MM/yyyy'
    if (rawFormat.includes('/yyy') && !rawFormat.includes('/yyyy')) {
      rawFormat = rawFormat.replace('/yyy', '/yyyy');
    } else if (rawFormat.includes('yyy-') && !rawFormat.includes('yyyy-')) {
      rawFormat = rawFormat.replace('yyy-', 'yyyy-');
    }
    
    this._settings.dateFormat = rawFormat;
    updateDateFormatCookie(rawFormat);
  }

  public setDelimiterSymbol(symbol: SvcDelimiterType): void {
    switch (symbol) {
      case SvcDelimiterType.DOT: {
        this._settings.delimiterSymbol = '.';
        break;
      }
      default: {
        this._settings.delimiterSymbol = ',';
        break;
      }
    }
    updateDelimiterTypeCookie(symbol ?? DEFAULT_DELIMITER_TYPE);
  }
  
}
